import { EligibilityRuleDTO, GetParametersResponse } from "./interfaces";
import { makeCoreGetRequest } from "../../utils/api";
import { ALLOWED_SORT_FIELDS } from "./constants";

export const isValidYearMonth = (value: string): boolean => {
  const match = value.match(/^(\d{4})-(\d{2})$/)
  if (!match) return false

  const year = Number(match[1])
  const month = Number(match[2])

  if (month < 1 || month > 12) return false
  return !(year < 1900 || year > 2100)
}

export const ruleToDate = (r: EligibilityRuleDTO) =>
  new Date(r.year, (r.month ?? 1) - 1, r.day ?? 1)

export const sortRulesDesc = (rules: EligibilityRuleDTO[]) =>
  [...rules].sort((a, b) => ruleToDate(b).getTime() - ruleToDate(a).getTime())

export const splitRulesByEffectiveDate = (
  rules: EligibilityRuleDTO[]
) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const sorted = sortRulesDesc(rules)

  const pastOrCurrent = sorted.filter(r => {
    const d = ruleToDate(r)
    d.setHours(0, 0, 0, 0)
    return d <= today
  })

  const future = sorted.filter(r => {
    const d = ruleToDate(r)
    d.setHours(0, 0, 0, 0)
    return d > today
  })

  return {
    currentRule: pastOrCurrent[0] ?? null,
    history: pastOrCurrent.slice(1),
    future,
  }
}

export const sanitize = (s: any) =>
  String(s ?? "")
    .replaceAll("|", " ")
    .replaceAll("\n", " ")
    .replaceAll("\r", " ")
    .trim()

export const normalizeOrder = (o?: string) => {
  const up = String(o ?? "").toUpperCase()
  return up === "ASC" ? "ASC" : up === "DESC" ? "DESC" : undefined
}

export const normalizeOrderBy = (ob: any) => {
  const field = typeof ob === "string" ? ob : ob?.field ?? ob?.name
  return ALLOWED_SORT_FIELDS.has(field) ? field : undefined
}
